import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import FreeForm from "@widgets/FreeForm";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { dateToString } from "@shared/utils/DateUtils";
import SnForm from "@widgets/SnForm";
import SnMemoBox from "@shared/components/SnMemoBox";
import { SnLabel } from "@shared/components/SnLabel";
interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_QMS_BAS_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [sharedForm, setSharedForm] = useState<any[]>([]);
    const SharedFormref1 = useRef<any>();
    const [memoValue, setMemoValue] = useState(
      selectedData?.data?.txt_explain ?? ""
    );
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>();
    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [memoValue],
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_QMS_BAS_REG_001_POP_001",
            {}
          );
          setFormData(rtn.formData);
          setSharedForm(rtn.form.freeform1);
          setFormControlData(rtn.formControlData);
          await new Promise((resolve) => setTimeout(resolve, 0));
        } catch (error: any) {}
      };
      fetchform();
    }, []);
    //#region Button Event
    //#endregion

    return (
      <div className="h-full flex flex-col overflow-x-hidden">
        <div className="w-full flex flex-col gap-2">
          <SnLabel text="설명" type="String" />
          <SnMemoBox
            defaultValue={selectedData.data.txt_explain}
            onValueChanged={(value: string) => {
              setMemoValue(value);
            }}
          />
        </div>
      </div>
    );
  }
);

export default SN_QMS_BAS_REG_001_POP_001;
